import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * Botón "Volver al inicio" para las pantallas de acceso (login, registro,
 * recuperar contraseña). Lleva a la landing principal sin depender del botón
 * "atrás" del navegador.
 */
const VolverInicio: React.FC = () => (
  <Button
    component={RouterLink}
    to="/"
    size="small"
    startIcon={<ArrowBackIcon />}
    sx={{ mb: 1, ml: -1, color: 'text.secondary', textTransform: 'none' }}
  >
    Volver al inicio
  </Button>
);

export default VolverInicio;
